"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisitorIdCookie = exports.setVisitorIdCookie = void 0;
const constants_1 = require("./constants");
const setVisitorIdCookie = (value) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + constants_1.EXPIRE_ONE_YEAR);
    document.cookie = `${constants_1.VISITOR_ID}=${value};expires=${expires.toUTCString()};path=/`;
};
exports.setVisitorIdCookie = setVisitorIdCookie;
const getVisitorIdCookie = () => {
    const cookieRegex = new RegExp(`(?:(?:^|.*;\\s*)${constants_1.VISITOR_ID}\\s*\\=\\s*([^;]*).*$)|^.*$`);
    const cookieMatch = document.cookie.match(cookieRegex);
    return cookieMatch && cookieMatch[1];
};
exports.getVisitorIdCookie = getVisitorIdCookie;
//# sourceMappingURL=visitorCookie.js.map